import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Home from './components/Home'
import Login from './components/Login'
import Questions from './components/Question/Questions'
import Tests from './components/Test/Tests'
import Test from './components/Test/Test'
import AddQuestions from './components/Test/AddQuestions'
import UserConfig from './components/User/UserConfig'
import Users from './components/User/Users'
import Subjects from './components/Subject/Subjects'

Vue.use(Router)

const isAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/login');
};

const isNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/');
}

const isAdmin = (to, from, next) => {
    if (store.getters.isAdmin) {
        next()
        return
    }
    next('/login')
}

const isTeacher = (to, from, next) => {
    if (store.getters.isTeacher) {
        next()
        return
    }
    next('/login')
}

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            beforeEnter: isAuthenticated,
            meta: {title: 'Medicii'}
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: isNotAuthenticated
        },
        {
            path: '/questions',
            name: 'Questions',
            component: Questions,
            beforeEnter: isAuthenticated
        },
        {
            path: '/tests',
            name: 'Tests',
            component: Tests,
            beforeEnter: isAuthenticated
        },
        {
            path: '/tests/:id',
            name: 'Test',
            component: Test,
            beforeEnter: isAuthenticated
        },
        {
            path: '/tests/:id/addQuestions',
            name: 'AddQuestions',
            component: AddQuestions,
            beforeEnter: isAuthenticated
        },
        {
            path: '/userConfig',
            name: 'UserConfig',
            component: UserConfig,
            beforeEnter: isAuthenticated
        },
        {
            path: '/users',
            name: 'Users',
            component: Users,
            beforeEnter: isAdmin
        },
        {
            path: '/subjects',
            name: 'Subjects',
            component: Subjects,
            beforeEnter: isAdmin
        },
    ]
})
